<template>
  <div class="ma-2">
    <v-container>
        <v-row>
          <v-col>
            <v-select :items="filiais" v-model="filial" clearable label="Empresa" item-text="cc_fil" item-value="cc_fil" @change="pesquisar()"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-form @submit="salvar()"  ref="form" v-model="valid" :lazy-validation="lazy" v-on:submit.prevent>
              <p class="font-weight-black">Par&acirc;metros gerais</p>
              <v-text-field v-model="parametros[4].vl_par" label="Teto máximo para sangria"></v-text-field>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" sm="3" md="3">
                    <v-checkbox v-model="parametros[3].vl_par" label="Exigir sangria na saída do operador"></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-checkbox v-model="parametros[2].vl_par" label="Permitir desconto no item adicionado ao pedido"></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-checkbox v-model="parametros[1].vl_par" label="Exigir cliente na abertura da venda"></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-checkbox v-model="parametros[0].vl_par" label="Consultar dados do cliente em recurso externo"></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
              
              <p class="font-weight-black">Integra&ccedil;&atilde;o DFEAPI</p>
              <v-text-field v-model="parametros[5].vl_par" label="URL"></v-text-field>
              <v-text-field v-model="parametros[6].vl_par" label="Token"></v-text-field>

              <p class="font-weight-black">Notifica&ccedil;&atilde;o NFC-e em modo off-line</p>
              <v-text-field v-model="parametros[7].vl_par" label="E-mail destinatário"></v-text-field>
              <v-text-field v-model="parametros[8].vl_par" label="E-mail remetente"></v-text-field>
              <v-checkbox v-model="parametros[9].vl_par" label="Notificar destinatário"></v-checkbox>
              
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn depressed color="primary" outlined @click="salvar()" :disabled="filial === null">salvar</v-btn>
          </v-col>
        </v-row>
        {{parametros}}
    </v-container>
  </div>
</template>
<script>
export default {

  name: 'Parametro',

  data: () => {
    return {

      valid:false,
      lazy:true,
      filial: null,
      filiais: [],

      parametros: [
        {
          cc_par: 'CONSULTA_CLIENTE_EXTERNO',
          vl_par: false,
          tx_par: false,
          ds_par: 'Consulta Cliente em uma base externa',
          cc_par_grp: 'VEN'
        },
        {
          cc_par: 'EXIGE_INFO_CLIENTE',
          vl_par: false,
          tx_par: false,
          ds_par: 'Exige Informações do Cliente',
          cc_par_grp: 'VEN'
        },
        {
          cc_par: 'PEMITE_DESCONTO_ITEM_ADICIONADO_PEDIDO',
          vl_par: false,
          tx_par: false,
          ds_par: 'Permite desconto no item adicionado ao um pedido',
          cc_par_grp: 'VEN'
        },
        {
          cc_par: 'SAIDA_OP_SANGRIA',
          vl_par: false,
          tx_par: false,
          ds_par: 'Exige sangria na Saida do operador',
          cc_par_grp: 'CXA'
        },
        {
          cc_par: 'TETO_SANGRIA',
          vl_par: '0.00',
          tx_par: '0.00',
          ds_par: 'Teto Maximo de Sangria',
          cc_par_grp: 'CXA'
        },
        {
          cc_par: 'URL_DFEAPI',
          vl_par: '',
          tx_par: '',
          ds_par: 'URL de integra\u00e7\u00e3o com a API de notas fiscais',
          cc_par_grp: 'CXA'
        },
        {
          cc_par: 'TOKEN_DFEAPI',
          vl_par: '',
          tx_par: '',
          ds_par: 'Token de identifica\u00e7\u00e3o da empresa na API de notas fiscais',
          cc_par_grp: 'CXA'
        },
        {
          cc_par: 'NFCE_OFFLINE_EMAIL_DESTINATARIO',
          vl_par: '',
          tx_par: '',
          ds_par: 'E-mail que recebe notifica\u00e7\u00e3o quando a NFC-e etiver operando em modo off-line',
          cc_par_grp: 'CXA'
        },
        {
          cc_par: 'NFCE_OFFLINE_EMAIL_REMETENTE',
          vl_par: '',
          tx_par: '',
          ds_par: 'E-mail do remetente',
          cc_par_grp: 'CXA'
        },
        {
          cc_par: 'NFCE_OFFLINE_NOTIFICA_DESTINATARIO',
          vl_par: false,
          tx_par: false,
          ds_par: 'Notifica destinat\u00E1rio que a emiss\u00e3o de NFC-e est\u00E1 operando em modo off-line',
          cc_par_grp: 'CXA'
        },
      ],

      validacao: {
        vl_par_4: [
          (v) => !!v || 'Requerido',
          //(v) => /^[0-9]*[.][0-9]+$/.test(v) || 'Formato inválido'
          //(v) => { if(v === undefined) {return 'Requerido'} else { return true } }
        ]
      }
    }
  },

  mounted: function () {

  },

  created: function () {
    this.$vuetify.goTo(0)
    this.populaFiliais()
  },

  methods: {

    salvar() {
      if (this.$refs.form.validate()) {

        this.parametros.forEach((el) => {
          
          el.cc_fil = this.filial
          el.tx_par = `${el.vl_par}`

          this.$store.dispatch('salvarParametro', el).then(() => {  }).catch(err => {
            console.log(err)
          })

        })

        

      }
    },

    pesquisar() {

      this.parametros.forEach((el) => {

        this.$store.dispatch('pesquisaParametro', {cc_fil: this.filial, cc_par: el.cc_par}).then(resp => {
          resp.data.content.forEach((i) => {
            el.tx_par = i.tx_par
            el.vl_par = (['true', 'false'].includes(i.tx_par)) ? JSON.parse(i.tx_par) : i.tx_par             
          })
        }).catch(err => {
          console.log(err)
        })

      })

    },

    populaFiliais() {
      this.$store.dispatch('obterFiliais', {}).then(resp => {
        this.filiais = resp.data.content
      }).catch(err => {
        console.log(err)
      })
    },

    resetarFormulario() {
      this.$refs.form.reset()
      this.filial = undefined
    },

  }
}
</script>